import type { ReactNode } from 'react';
import { Button } from '@cbhq/cds-web/buttons';
import { HStack } from '@cbhq/cds-web/layout';
import { PageFooter } from '@cbhq/cds-web/page/PageFooter';

type SaveFooterProps = {
  visible: boolean;
  loading: boolean;
  onSave: () => void;
  children: ReactNode;
};

export function SaveFooter({ visible, loading, onSave, children }: SaveFooterProps) {
  return (
    <div
      style={{
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
        transition: 'transform 220ms ease-out, opacity 220ms ease-out',
      }}
    >
      <PageFooter
        height="auto"
        action={
          <HStack justifyContent="flex-end" alignItems="center">
            <Button variant="primary" compact onClick={onSave} loading={loading}>
              {children}
            </Button>
          </HStack>
        }
      />
    </div>
  );
}
